import React, { useState, useEffect } from 'react';
import { Modal, Button } from 'react-bootstrap';

interface Recipe {
  id: number;
  name: string;
  ingredients: string[];
  instructions: string[];
}

interface RecipeSelectionModalProps {
  show: boolean;
  onHide: () => void;
  recipes: Recipe[];
  onSelectRecipe: (recipe: Recipe) => void;
}

const RecipeSelectionModal: React.FC<RecipeSelectionModalProps> = ({ show, onHide, recipes, onSelectRecipe }) => {
  const [searchTerm, setSearchTerm] = useState('');
  const [filteredRecipes, setFilteredRecipes] = useState<Recipe[]>([]);

  useEffect(() => {
    if (searchTerm) {
      setFilteredRecipes(
        recipes.filter(recipe =>
          recipe.name.toLowerCase().includes(searchTerm.toLowerCase())
        )
      );
    } else {
      setFilteredRecipes(recipes);
    }
  }, [searchTerm, recipes]);

  return (
    <Modal show={show} onHide={onHide} centered>
      <Modal.Header closeButton>
        <Modal.Title>Select a Recipe</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <input
          type="text"
          className="form-control mb-3"
          placeholder="Search recipes..."
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
        />
        <ul className="list-group">
          {filteredRecipes.map(recipe => (
            <li key={recipe.id} className="list-group-item list-group-item-action" onClick={() => onSelectRecipe(recipe)}>
              {recipe.name}
            </li>
          ))}
          {filteredRecipes.length === 0 && <li className="list-group-item">No recipes found.</li>}
        </ul>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onHide}>
          Close
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default RecipeSelectionModal;
